import { useState, ChangeEvent } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { Flex, Text } from '@backstage/ui';
import { FieldHint } from '../../components/FieldHint';
import styles from './ZipUploadPicker.module.css';

export const ZipUploadPicker = ({
  onChange,
  schema,
  required,
  rawErrors,
  formData,
}: FieldExtensionComponentProps<string>) => {
  const [fileName, setFileName] = useState<string | undefined>();
  const [localError, setLocalError] = useState<string | undefined>();

  const helperText =
    localError ||
    schema.description ||
    'Selecione um arquivo .zip para enviar';
  const hasError = ((rawErrors?.length ?? 0) > 0 && !formData) || !!localError;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setLocalError(undefined);
    const file = event.target.files?.[0];

    if (!file) {
      setFileName(undefined);
      onChange(undefined as unknown as string);
      return;
    }

    if (!file.name.toLowerCase().endsWith('.zip')) {
      setFileName(undefined);
      setLocalError('Envie um arquivo .zip');
      onChange(undefined as unknown as string);
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(',')[1] ?? '';
      setFileName(file.name);
      onChange(base64);
    };
    reader.onerror = () => {
      setFileName(undefined);
      setLocalError('Falha ao ler o arquivo');
      onChange(undefined as unknown as string);
    };
    reader.readAsDataURL(file);
  };

  return (
    <Flex direction="column">
      <Text variant="title-small">
        {schema.title || 'Arquivo .zip'}
        {required ? ' *' : ''}
      </Text>
      <label className={styles.fileButton}>
        Selecionar arquivo .zip
        <input type="file" accept=".zip" hidden onChange={handleChange} />
      </label>
      {fileName && <Text variant="body-small">{fileName}</Text>}
      <FieldHint error={hasError}>
        {hasError ? localError || rawErrors?.join(', ') : helperText}
      </FieldHint>
    </Flex>
  );
};
